import React from "react";
import { LayoutWrapper } from "../../components/layoutWrapper";
import {
  CircularProgress,
  Container,
  List,
  ListItem,
  ListItemText,
  Typography,
} from "@material-ui/core";
import { Alert } from "@material-ui/lab";
import useStyles from "../../components/util/styles";
import { getMarketReports } from "../../lib/marketReportRequests";
import { MarketReport } from "../../types/MarketReport";

const MarketReports: React.FC = () => {
  const classes = useStyles();
  const [marketReports, setMarketReports] = React.useState<MarketReport[]>([]);
  const [loading, setLoading] = React.useState(true);
  const [error, setError] = React.useState("");

  React.useEffect(() => {
    const loadMarketReports = async () => {
      try {
        const response = await getMarketReports();
        setMarketReports(response.marketReports);
      } catch (err: any) {
        setError(
          err?.message || "Market reports could not be loaded. Please try again."
        );
      } finally {
        setLoading(false);
      }
    };
    loadMarketReports();
  }, []);

  return (
    <LayoutWrapper pathName="marketReports">
      <Container maxWidth="lg" className={classes.container}>
        <h1>Market Reports</h1>

        {error ? <Alert severity="error">{error}</Alert> : null}

        {loading ? (
          <CircularProgress />
        ) : !error && marketReports.length === 0 ? (
          <Typography color="textSecondary">
            There are no market reports available yet.
          </Typography>
        ) : (
          <List>
            {marketReports.map(({ id, title, file_url }) => {
              return (
                <ListItem
                  key={id}
                  button
                  component="a"
                  href={file_url}
                  target="_blank"
                >
                  <ListItemText primary={title} />
                </ListItem>
              );
            })}
          </List>
        )}
      </Container>
    </LayoutWrapper>
  );
};

export default MarketReports;
